import React, {useContext} from "react";
import AnnualReportTableCell from "./AnnualReportTableCell";
import FormTranslationContext from "context/FormTranslationContext";
import {Tooltip} from "@material-ui/core";

function AnnualReportTableHeadCell(
    {
        label,
        className,
        borderRight,
        borderLeft = true,
        maxWidth,
        ...props
    }
) {
    const {formTr, formTip} = useContext(FormTranslationContext);
    const tip = formTip(label);
    return (<AnnualReportTableCell style={maxWidth ? {maxWidth: maxWidth} : undefined} borderLeft={borderLeft} borderRight={borderRight} className={className} {...props}>
        {
            !!tip ? <Tooltip title={tip}>
                <div>{formTr(label)}</div>
            </Tooltip> : <div>{formTr(label)}</div>
        }
    </AnnualReportTableCell>);

}


export default AnnualReportTableHeadCell;